import _default from './Grid';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/collections/Grid/index.js
// module id = 1745
// module chunks = 0